var _rect, _rect2, _rect3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoadingBars = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 8,
    x: 10,
    fill: "current",
    width: 16,
    height: 100,
    transform: "translate(0) rotate(180 18 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1s",
    values: "30; 100; 30",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    rx: 8,
    x: 42,
    fill: "current",
    width: 16,
    height: 100,
    transform: "translate(0) rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1s",
    values: "30; 100; 30",
    repeatCount: "indefinite",
    begin: "0.3s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    rx: 8,
    x: 74,
    fill: "current",
    width: 16,
    height: 100,
    transform: "translate(0) rotate(180 82 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1s",
    values: "30; 100; 30",
    repeatCount: "indefinite",
    begin: "0.1s"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingBars, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading-bars.fd8efce1.svg";
export { ForwardRef as ReactComponent };